import RomanceImg from './../images/genre-1.webp';
import ActionImg from './../images/genre-2.webp';
import MystryImg from './../images/genre-3.webp';
import FanatsyImg from './../images/genre-4.webp';
import HFictionImg from './../images/genre-5.webp';
import HorrorImg from './../images/genre-6.webp';
import BioImg from './../images/genre-7.webp';
import ChildImg from './../images/genre-8.webp';
import AdultImg from './../images/genre-9.webp';
import LiteraryImg from './../images/genre-10.webp';
import NonFictionImg from './../images/genre-11.webp';
import ScienceImg from './../images/genre-12.webp';





const CategoryData = [
    {
        title: "ROMANCE",
        id: "1",
        img: RomanceImg
    },
    {
        title: "ACTION",
        id: "2",
        img: ActionImg
    },
    {
        title: "MYSTERY",
        id: "3",
        img: MystryImg
    },
    {
        title: "FANTASY",
        id: "4",
        img: FanatsyImg
    },
    {
        title: "HISTORICAL FICTION",
        id: "5",
        img: HFictionImg
    },
    {
        title: "HORROR",
        id: "6",
        img: HorrorImg
    },
    {
        title: "BIOGRAPHIES",
        id: "7",
        img: BioImg
    },
    {
        title: "CHILDERN'S",
        id: "8",
        img: ChildImg
    },
    {
        title: "YOUNG & ADULT",
        id: "9",
        img: AdultImg
    },
    {
        title: "LITERARY FICTION",
        id: "10",
        img: LiteraryImg
    },
    {
        title: "NON-FICTION",
        id: "11",
        img: NonFictionImg
    },
    {
        title: "SCIENCE FICTION",
        id: "12",
        img: ScienceImg
    }
]

export default CategoryData;